

import React, { Component } from 'react';
import { connect } from 'react-redux'
import StoreComponent from '../store/store';
import OrderConfirmation from '../confirmation/orderConfirmation';

const stringUtil = require('../../../../utils/string/stringUtil');
const stateManager = require('../../../../utils/state/stateManager');
const basketUtil = require('../../../../utils/basket/basketUtil');
class Home extends Component 
{
    render()
    {

        //If require we will show list of stores here.
        if(stringUtil.areStringSame(stateManager.getStore().getState().currentComponent, "confirmation"))
            return <OrderConfirmation
                        onClose={()=>
                        {
                            basketUtil.resetBasket();
                            stateManager.getStore().getState().user = null;
                            this.props.onDismiss();
                        }}/>
        else
            return <StoreComponent/>
    }
}

const mapStateToProps = state => 
{
    return { 
        currentComponent: state.currentComponent,
    }
}

export default connect(mapStateToProps)(Home)